import { Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import AddressEntry from "../../Components/AddressEntry/AddressEntry";
import { addAddress, removeAddress, updateAddressInformation } from "../../redux/user/userSlice";
import { API, getCredentialTypeCode } from "../../utils/http";
import { addressListVerifier } from "../../utils/verifier";
import AddressInformationTable from "./AddressInformationTable";
const initialAddress = {
	streetLine1: "",
	streetLine2: "",
	city: "",
	province: "",
	postalCode: "",
	country: "",
	dateMoveIn: null,
	dateMoveOut: null,
	addressType: 1,
};
export default function AddressInformation(props) {
	const { verifier, renderControls, handleNext, handleBack } = props;
	const dispatch = useDispatch();
	const addressInformation = useSelector((state) => state.user.application.addressInformation);
	const personalInformation = useSelector((state) => state.user.application.personalInformation);
	const { t } = useTranslation();
	const [error, setError] = useState(
		addressInformation.map((e) => {
			return {};
		})
	);
	const [nextError, setNextError] = useState({});

	const [address, setAddress] = useState(addressInformation);
	const [formVisible, setFormVisible] = useState(addressInformation.length == 0);
	useEffect(() => {
		console.log(addressInformation);
		if (addressInformation.length == 0) setAddress([initialAddress]);
		else setAddress(addressInformation);
	}, [addressInformation]);
	useEffect(() => {
		console.log(address);
	}, [address]);
	const handleDateMovedInChange = (newValue, index) => {
		const tempAddress = [...address];
		tempAddress[index] = { ...tempAddress[index], dateMoveIn: newValue?.isValid?.() ? newValue.format("YYYY-MM-DD") : "" };
		setAddress(tempAddress);
	};
	const handleDateMovedOutChange = (newValue, index) => {
		const tempAddress = [...address];
		tempAddress[index] = { ...tempAddress[index], dateMoveOut: newValue?.isValid?.() ? newValue.format("YYYY-MM-DD") : "" };
		setAddress(tempAddress);
	};
	const handleEditAddress = (index) => {
		const errors = verifier(address);
		if (Object.keys(errors).length == 0) {
			console.log();
			dispatch(addAddress(address));
		}
		console.log("edit index ", index);
		const addr = addressInformation[index];
		setAddress(addr);
		handleRemoveAddress(index);
		setFormVisible(true);
	};
	const handleRemoveAddress = (index) => {
		console.log("remove index ", index);
		dispatch(removeAddress(index));
	};
	const updateAddressApi = (callbak) => {
		const payload = address.map((a, index) => {
			if (index == 0) return { ...a, addressType: 0 };
			return a;
		});
		const credentialTypeCode = getCredentialTypeCode();
		console.log("payload: ", payload);
		API.put("application", {
			id: personalInformation.id,
			addressInformation: payload,
			credentialTypeCode,
		})
			.then((r) => {
				console.log(r);
				dispatch(updateAddressInformation(payload));
				callbak();
				toast.success("Address Information Updated");
			})
			.catch((e) => {
				console.log(e);
				toast.error("Address Information Update Failed");
			});

		// setNextError({});
	};
	const handleNextButton = () => {
		console.log("address info: ", address);
		const errors = addressListVerifier(address);
		console.log(errors);
		setError(errors);
		console.log(addressInformation);
		//if errors array containts only null values, then there are no errors
		if (!errors.every((e) => e == null) || address.length === 0) {
			console.log("errors");
			toast.error("Please fill in all required fields");
			return;
		}
		updateAddressApi(() => {
			handleNext();
		});
	};
	const handleAdd = () => {
		const errors = verifier(address);
		console.log(errors);
		if (Object.keys(errors).length === 0) {
			dispatch(addAddress(address));
			setAddress(initialAddress);
			setError({});
			setFormVisible(false);
		} else {
			setError(errors);
		}
	};
	const addNewForm = () => {
		//sent prev addresses to api
		const errors = addressListVerifier(address);
		console.log(errors);
		setError(errors);
		console.log(addressInformation);
		//if errors array containts only null values, then there are no errors
		if (!errors.every((e) => e == null)) {
			console.log("errors");
			return;
		}
		updateAddressApi(() => {
			dispatch(addAddress(initialAddress));
		});
	};
	const handleSearchResult = (add, index) => {
		let tempAddress = [...address];
		tempAddress[index] = { ...tempAddress[index], ...add };
		setAddress(tempAddress);
	};
	const handleAddressChange = (e, index) => {
		const tempAddress = [...address];
		tempAddress[index] = { ...tempAddress[index], [e.target.name]: e.target.value };
		setAddress(tempAddress);
	};
	const renderAddressForm = (a, index) => (
		<>
			{index == 0 && (
				<Grid item xs={12}>
					<Typography fontWeight={"bold"}>Current Address:</Typography>
				</Grid>
			)}
			{index == 1 && (
				<Grid item xs={12}>
					<Typography fontWeight={"bold"}>Previous Addresses:</Typography>
				</Grid>
			)}
			<AddressEntry
				key={index}
				addressInformation={a}
				index={index}
				errors={error[index]}
				handleChange={handleAddressChange}
				handleDateMovedInChange={handleDateMovedInChange}
				handleDateMovedOutChange={handleDateMovedOutChange}
				handleDelete={handleRemoveAddress}
				handleSearchResult={handleSearchResult}
			/>
		</>
	);

	return (
		<React.Fragment>
			<Typography>&nbsp;</Typography>
			<Typography>{t("Address Information Requirements Line")}</Typography>
			<Typography>&nbsp;</Typography>
			<Typography>&nbsp;</Typography>
			<Grid container spacing={2}>
				{address.map((a, index) => renderAddressForm(a, index))}

				<Grid item xs={12} textAlign="center">
					<Button variant="contained" onClick={addNewForm} sx={{ textTransform: "none" }} color="primary">
						Add Previous Address
					</Button>
				</Grid>
				<Grid item xs={12} textAlign="right" display={"none"}>
					<Button
						variant="contained"
						onClick={() => {
							if (formVisible) handleAdd();
							else setFormVisible(true);
						}}
						sx={{ textTransform: "none" }}
						color="primary"
					>
						{formVisible ? t("Add Address") : t("Add a new Address")}
					</Button>
				</Grid>
				<Grid item xs={12} display={!nextError.addressList ? "none" : "initial"} textAlign="center">
					<Typography color="error">{nextError.addressList}</Typography>
				</Grid>
				<Grid item xs={12} display="none">
					<AddressInformationTable rows={addressInformation} removeAddress={handleRemoveAddress} editAddress={handleEditAddress} />
				</Grid>
			</Grid>
			{renderControls(handleNextButton, handleBack)}
		</React.Fragment>
	);
}
